<template>
  <div id="COUploadCertificate">
    <section>
      <div id="container-center" style="width:1360px">
        <div class="labelTitle lable">ケア オーケストレータークライアント認証申込施設検索</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>医療機関名</th>
              <td><input type="text" v-model="searchConditions.hospitalName"/></td>
              <th>郵便番号</th>
              <td style="border-right:hidden;"><input type="text" v-model="searchConditions.postCode"/></td>
              <th style="background-color:white;border-right:hidden;"></th>
              <td style="border-right:hidden;"></td>
              <th style="background-color:white;border-right:hidden;"></th>
              <td></td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <div>
            <b-table
              :data="data"
              :paginated="true"
              per-page="20"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="careOrchestratorInstitutionId" label="医療機関ID" class="breakAll" sortable>
                  <router-link :to="{name:'COSettingHospitalInternal', params:{careOrchestratorInstitutionId: props.row.careOrchestratorInstitutionId, certificationFlag: props.row.certificationFlag, searchConditions:searchConditions}}"><a>{{props.row.careOrchestratorInstitutionId}}</a></router-link>
                </b-table-column>
                <b-table-column field="medicalInstitutionName" label="医療機関名" class="breakAll" sortable>{{props.row.medicalInstitutionName}}</b-table-column>
                <b-table-column field="belongsName" label="依頼元" class="breakAll" sortable>{{props.row.belongsName}}</b-table-column>
                <b-table-column field="postcode" label="郵便番号" class="breakAll" style="width: 100px;" sortable>{{props.row.postcode}}</b-table-column>
                <b-table-column field="address1" label="住所" class="breakAll" sortable>{{props.row.prefecture}}{{props.row.city}}{{props.row.address1}}{{props.row.address2}}</b-table-column>
                <b-table-column field="issuedDate" label="証明書発行日" class="breakAll" sortable>{{props.row.issuedDate}}</b-table-column>
                <b-table-column field="downloadExpirationDate" label="ダウンロード期限日" class="breakAll" sortable>{{props.row.downloadExpirationDate}}</b-table-column>
                <b-table-column field="expirationDate" label="証明書有効期限日" class="breakAll" sortable>
                  <span :class="getClass4ExpirationDate(props.row.expirationDate)">
                    {{props.row.expirationDate}}
                  </span>
                </b-table-column>
                <b-table-column field="password" label="パスワード" class="breakAll" sortable>{{props.row.password}}</b-table-column>
              </template>
            </b-table>
          </div>
        </div>
        <div style="margin-top:10px;">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {coStatus,coStatusStr} from "@/components/mock/base/const.js";
export default {
  name: "COUploadCertificate",
  methods: {
    back: function() {
      this.$router.push({ path: "COHome" });
    },
    doSearch: function() {
      var executeApi = this.getCoInstitutionInfoListPOST;
      var successCallBack = this.getCoInstitutionInfoListPOSTSuccess;
      var errorCallBack = this.getCoInstitutionInfoListPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    getCoInstitutionInfoListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalCo.getCoInstitutionInfoListPOST({
        body:obj
      });
    },
    getCoInstitutionInfoListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getCoInstitutionInfoListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    let searchConditions= {hospitalName:"", postCode:""}
    if(this.$route.params["searchConditions"]){
      searchConditions = this.$route.params["searchConditions"]
    }
    return {
      searchConditions: searchConditions,
      data: [],
      isPaginated: true,
      targetDate:"",
      password:"",
      targetFiles:{},
      tmpFileList:[],
      coStatus,
      coStatusStr,
    };
  },
  filters: {},
  components: {},
  async mounted() {
    if(this.$route.params["searchConditions"]){
      await this.doSearch();
    }
  },
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
.expirationDate{
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/COUploadCertificate.vue